import { variables } from 'swag-client-common/styles/variables-js';
const STYLES = {
  saveButton: {
    // eslint-disable-next-line spellcheck/spell-checker
    backgroundColor: variables.colorPrimaryIe,
    padding: '8px 16px',
    fontSize: '12px',
    width: '100%',
    marginTop: '15px'
  },
  revertButton: {
    padding: '8px 16px',
    fontSize: '12px',
    margin: '0',
    width: '100%'
  }
};
export default STYLES;